import { render, staticRenderFns } from "./AppSaveConfigAndRestartBtn.vue?vue&type=template&id=6db78f35&"
import script from "./AppSaveConfigAndRestartBtn.vue?vue&type=script&lang=ts&"
export * from "./AppSaveConfigAndRestartBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports